module.exports = __webpack_public_path__ + "static/media/StepCheck.8b802794.svg";